import { render, staticRenderFns } from "./fanTreeDiagram.vue?vue&type=template&id=5843a636&scoped=true"
import script from "./fanTreeDiagram.vue?vue&type=script&lang=js"
export * from "./fanTreeDiagram.vue?vue&type=script&lang=js"
import style0 from "./fanTreeDiagram.vue?vue&type=style&index=0&id=5843a636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5843a636",
  null
  
)

export default component.exports